import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'
import SecurityCentralTemplate from '../../templates/SecurityCentralTemplate'
import {
  login,
  changePassword,
  deactivateAccount,
  deleteAccount,
  downloadAccountData,
  myAccount,
} from '../../../settings/staticUrl'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  max-width: 680px;
  @media (max-width: 577px) {
    margin-left: 0;
  }
`

const TitleWrapper = styled(View)`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`

const onLoginPage = () => {
  window.location.href = login
}
const onChangePasswordPage = () => {
  window.location.href = changePassword
}
const onDeleteAccountPage = () => {
  window.location.href = deleteAccount
}
const onDeactivateAccountPage = () => {
  window.location.href = deactivateAccount
}
const onDownloadAccountDataPage = (email = '') => {
  window.location.href = `${downloadAccountData}?email=${email}`
}
const onMyAccountPage = () => {
  window.location.href = myAccount
}

export const SecurityCentralPage = ({ fragment, abTests }) => (
  <Content>
    <TitleWrapper>
      <Text size="title1">Segurança e privacidade</Text>
      <Text size="caption" color="grayscale.darker">
        Aumente a segurança e tenha o controle da sua conta
      </Text>
    </TitleWrapper>
    <SecurityCentralTemplate
      onDeleteSessionsSuccess={onLoginPage}
      onChangePassword={onChangePasswordPage}
      onDeleteAccount={onDeleteAccountPage}
      onDeactivateAccount={onDeactivateAccountPage}
      onDownloadAccountData={onDownloadAccountDataPage}
      onMyAccount={onMyAccountPage}
      fragment={fragment}
      abTests={abTests}
    />
  </Content>
)

SecurityCentralPage.propTypes = {
  fragment: PropTypes.string,
  abTests: PropTypes.string,
}

SecurityCentralPage.defaultProps = {
  fragment: '',
  abTests: '',
}
